<template>
  <div class="hello">

    <div class="container">
     <div class="item">


        <p id="title">Startup Application Tracking</p>

        <form v-on:submit.prevent="checkStatus">
          <input type="tel" class="form-control" v-model="mobile" placeholder="10 Digit Mobile" id="mobile" required v-on:keyup="onChange()" minlength="10" maxlength="10">
          <br>
          <input type="email" class="form-control" v-model="email" placeholder="Email Address" id="email" required v-if="show == true" v-on:keyup="showB()">
          <br>
          <input type="submit" value="Check Status" class="btn btn-primary btn-block button" v-if="showButton == true"/>
          <!-- <button type="button" class="btn btn-primary btn-block" v-on:click="checkStatus()" v-if="showButton == true">Check Status</button> -->
          <br>
        </form>
          <i class="fa fa-circle-o-notch fa-spin" style="font-size:24px" v-if="submitLoader"></i>
        <br>

            <table class="table .table-bordered .table-hover" v-if="showStatus == true && showTable == true">
              <thead >
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Startup</th>
                  <th scope="col">Name</th>
                  <th scope="col">Mobile</th>
                  <th scope="col">Email</th>
                  <th scope="col">Status</th>
                  <th scope="col">Reason</th>
                  <th scope="col">Comments</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(val, index) in array">
                  <td>{{index+1}}</td>
                  <td>{{val.startup}}</td>
                  <td>{{val.fname}} {{val.lname}}</td>
                  <td>{{val.mobile}}</td>
                  <td>{{val.email}}</td>
                  <td>{{val.status}}</td>
                  <td>{{val.reason}}</td>
                  <td>

                    <p v-if="val.status == 'Selected'">
                      Congratulations! You will receive an email with further details.
                    </p>
                    <p v-if="val.status == 'Shortlisted'">
                      Congratulations! Your application is shortlisted and you will receive an email with further details for the next round of scrutiny if you have not received already.
                    </p>
                    <p v-if="val.status == 'Under Review'">
                      It usually takes up to 30-45 working days
                      to review your application. Please allow
                      adequate time for review and check back later
                      for an updated status on your application.
                    </p>
                    <p v-if="val.status == 'Decision Taken'">
                      A decision on your application has been taken
                      and conveyed to you, either in person,
                      or through an email.
                    </p>
                    <p v-if="val.status == 'Not Selected'">
                      Your application was reviewed by a competent authority and was not found suitable for startup support at GUSEC. Due to the large volume of applications, we are unable to provide individual feedback on all applications via this platform. However, you are free to get in touch with us if you wish to get clarification on this decision taken on your application. You are also most welcome to apply for a different or an updated version of your idea using the Apply button on the GUSEC website.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>

            <p v-if="showNotFound == true">
              Sorry, record not found.<br><br>

              Are you entering the right phone number and the<br>
              email address that you submitted at the time of<br>
              application at GUSEC?<br><br>

              If not, application tracking will not work.<br>
              Furthermore, please note it may take up to<br>
              3 working days after your submitting an application<br>
              for our application tracking system to work.<br>

            </p>

        <template v-if="showTable == false" v-for="val in array">
            <h3 v-if="showStatus == true">{{val.fname}} {{val.lname}}</h3>
            <p v-if="showStatus == true && val.status == 'Selected'">
              Application Status: {{val.status}}<br><br>
              Congratulations! You will receive an email with further details.
            </p>
            <p v-if="showStatus == true && val.status == 'Shortlisted'">
              Application Status: {{val.status}}<br><br>
              Congratulations!<br>
              Your application is shortlisted and you will<br>
              receive an email with further details for the<br>
              next round of scrutiny if you have not received already.
            </p>
            <p v-if="showStatus == true && val.status == 'Under Review'">
              Application Status: {{val.status}}<br><br>
              It usually takes up to 30-45 working days <br>
              to review your application. Please allow <br>
              adequate time for review and check back later<br>
              for an updated status on your application.
            </p>
            <p v-if="showStatus == true && val.status == 'Decision Taken'">
              Application Status: {{val.status}}<br><br>
              A decision on your application has been taken<br>
              and conveyed to you, either in person,<br>
              or through an email.
            </p>
            <p v-if="showStatus == true && val.status == 'Not Selected'">
              Application Status: {{val.status}}
            </p>
            <p v-if="showStatus == true && val.status == 'Not Selected' && val.reason">
              Reason: {{val.reason}}
            </p>
            <p v-if="showStatus == true && val.status == 'Not Selected'">
              Your application was reviewed by a competent <br>
              authority and was not found suitable for startup<br>
              support at GUSEC.<br>
              Due to the large volume of applications, we are unable<br>
              to provide individual feedback on all applications <br>
              via this platform. <br>
              However, you are free to get in touch with us if you wish<br>
              to get clarification on this decision taken on your application.<br>
              You are also most welcome to apply for a different or an<br>
              updated version of your idea using the Apply button on the GUSEC website.
            </p>
            <p v-if="showNotFound == true">
              Sorry, record not found.<br><br>

              Are you entering the right phone number and the<br>
              email address that you submitted at the time of<br>
              application at GUSEC?<br><br>

              If not, application tracking will not work.<br>
              Furthermore, please note it may take up to<br>
              3 working days after your submitting an application<br>
              for our application tracking system to work.<br>

            </p>
          </template>

        <br>

     </div>


    </div>

    <!-- Footer -->

<div class="container">
  <div class="row justify-content-md-center">
    <div class="col-md-auto">
              <p id="message">
                <b>Note:</b> This application tracking system is only for applications made for startup support (incubation) using the application page at <a href="https://gusec.edu.in/apply" target="_blank">https://gusec.edu.in/apply</a>. If you have applied for accelerateBHARAT, CIF, herSTART, STARTfest or any other such program of GUSEC, application tracking will not work for those applications. For any queries, please write to us at contact@gusec.edu.in.
              </p>
    </div>
  </div>
</div>

<p>
  <a href="https://gusec.edu.in/" target="_blank">GUSEC Website </a>| <a href="https://gusec.edu.in/apply/" target="_blank">Apply for Startup at GUSEC</a>
</p>

    <p>Powered By:<br>
      <a href="https://www.easilydone.in/" target="_blank" class="link">
        <img id="image" src="/static/img/easilydone.png" style="height:2.5em">
      </a>
    </p>

      <!-- This is an experimental feature developed by <a href="http://www.easilydone.in/" target="_blank">EasilyDone</a>, a startup supported by GUSEC -->


  </div>
</template>

<script>

import { db } from '../main'
// import Swal from 'sweetalert2'

export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      applications: [],
      mobile: "",
      email: "",
      fname: "",
      lname: "",
      status: "",
      show: false,
      showButton: false,
      showStatus: true,
      submitLoader: false,
      showNotFound: false,
      statusMessage: "",
      showTable: false,
      array: []
    }
  },
  mounted(){
    console.log("Component Mounted");
    // this.GetData();
  },
  methods: {
    GetData(){

      console.log("Get Data");

      db.collection('application-status')
        .get()
        .then(snap => {
          const testCollection = [];
          snap.forEach(doc => {
            testCollection.push(doc.data());
          });
          this.applications = testCollection;
          console.log("Total Applications: "+this.applications.length);
        });

    },
    onChange(){
      console.log(this.mobile.length);
      if(this.mobile.length == 10){
        this.show = true;
      }else{
        this.show = false;
      }
    },

    showB(){
      console.log(this.mobile.length);
      if(this.email.length > 8){
        this.showButton = true;
      }else{
        this.showButton = false;
      }
    },

    checkStatus(){

      this.showNotFound = false;
      this.showStatus = false;

      this.submitLoader = true;

      console.log("Checking Status...");
      console.log("Mobile: "+this.mobile);
      console.log("Email: "+this.email);

        // Query firebase

        db.collection('application-status')
        .where("mobile","==",this.mobile)
        .where("email","==",this.email)
        .get()
        .then((doc) => {

            var length = doc.docs.length;
            console.log("Length: "+length);

            this.submitLoader = false;

            if(length > 1){
              this.showTable = true;
            }

            if(length > 0){

              this.showStatus = true;

              var i = 0;

              doc.docs.forEach(info => {

                console.log(info.id);
                console.log(info.data());
                console.log(info.data().fname);
                console.log(info.data().lname);
                console.log(info.data().mobile);
                console.log(info.data().startup);

                this.fname = info.data().fname;
                this.lname = info.data().lname;
                this.mobile = info.data().mobile;
                this.email = info.data().email;
                this.status = info.data().status;

                var info = {
                  fname: info.data().fname,
                  lname: info.data().lname,
                  mobile: info.data().mobile,
                  email: info.data().email,
                  status: info.data().status,
                  startup: info.data().startup,
                  reason: info.data().reason
                };

                this.array.push(info);

              })

            }else{

              console.log("Not Found");
              this.showNotFound = true;
              // const Swal = require('sweetalert2')
              // Swal.fire({
              //   title: 'Sorry!',
              //   // html:'<h2>'+info.status+'</h2>',
              //   html:'Record not found. Please try again.',
              //   type: 'error',
              //   showConfirmButton: false,
              //   // timer: 1500
              // })

            }


        }).catch((err) => {
          // alert("No registrations")
          console.log(err)

              console.log("Record Not Found");
              // const Swal = require('sweetalert2')
              // Swal.fire({
              //   title: 'Sorry!',
              //   // html:'<h2>'+info.status+'</h2>',
              //   html:'Record not found. Please try again.',
              //   type: 'error',
              //   showConfirmButton: false,
              //   // timer: 1500
              // })

        })

// end query firebase


        // this.applications.map((info)=>{
        //   if(this.mobile == info.mobile && this.email == info.email){
        //
        //     console.log("Record Found");
        //     console.log(info.name);
        //     console.log(info.email);
        //
        //     this.showStatus = true;
        //
        //     this.name = info.name;
        //     this.mobile = info.mobile;
        //     this.email = info.email;
        //     this.status = info.status;
        //
        //   }else{
        //
        //
        //
        //
        //   }
        //
        // });

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.container{
     display: flex;
     flex-direction: row;
     align-items: center;
     align-content: center;
     justify-content: center;
     /* height: 80%; */
     /* border: 1px solid red; */
  }

  .item{
     align-self: center;
     align-items: center;
     align-content: center;
     justify-content: center;
  }

  .item2{
     align-self: center;
     align-items: center;
     align-content: center;
     justify-content: center;
  }

  #title{
   font-weight: 200;
   font-size: 2em;
  }

  #footerMsg{
    font-size: 0.7em;
    font-style: italic;
  }

  #message{
    text-align: left;
    padding: 1em;
    /* padding: em; */
  }

  .link{
    /* border: 1px solid red; */
  }

  .button{
    background-color: #1e90ff;
  }

</style>



// WEBPACK FOOTER //
// Dash.vue?719f77b6